import fwUrlUtils from "../../utils/fwUrlUtils";

export const MESSAGE_URL = fwUrlUtils.getApiUrl("/config/messages/{0}/{1}");
export const PERMISSION_URL = fwUrlUtils.getApiUrl("/config/user/permissions");
export const MENU_URL = fwUrlUtils.getApiUrl("/config/menu");
export const FOOTER_URL = fwUrlUtils.getApiUrl("/config/footer");
